import React from 'react'
import { EyeIcon, EyeSlashIcon } from './Icons'

export const PasswordInput = ({ 
  id, 
  name, 
  value, 
  onChange, 
  onBlur, 
  placeholder,
  showPassword,
  onTogglePassword,
  error,
  touched,
  className = ""
}) => {
  return (
    <div className="relative">
      <input
        id={id}
        name={name}
        type={showPassword ? "text" : "password"}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        className={`w-full px-3 py-2.5 pr-10 border rounded-md focus:ring-2 focus:ring-teal-100 focus:border-teal-500 transition-colors text-sm ${
          error && touched ? 'border-red-500' : 'border-gray-300'
        } ${className}`}
        placeholder={placeholder}
      />
      <button
        type="button"
        onClick={onTogglePassword}
        className="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700"
      >
        {showPassword ? <EyeSlashIcon /> : <EyeIcon />}
      </button>
    </div>
  )
}
